<template>
    <qmWxBtn>
        <div class="rank-bg" :style="{ height: `${minHeight}px` }">
            <div class="rank-list">
                <div class="rank-content">
                    <div :class="['rank-tab-bg', currentTab === '1' ? '' : 'rank-tab-bg-right']">
                        <div class="tab-bg-1"></div>
                        <div class="tab-bg-2"></div>
                        <img class="tab-img" :rotate="currentTab === '2'" src="@/assets/images/wish_home_img_middleslice.png" alt="">
                    </div>
                    <div class="rank-wrapper">
                        <ul class="rank-tab-list">
                            <li @click="onTabClick('1')" :disabled="currentTab === '2'">男频书籍</li>
                            <li @click="onTabClick('2')" :disabled="currentTab === '1'">女频书籍</li>
                        </ul>
                        <div class="rank-content-list" :class="currentTab === '1' ? '' : 'rank-content-list-right'">
                            <div :class="['rank-search', (voteType || onlyExtra) ? 'rank-search-radio-only' : '']">
                                <q-input
                                    @blur="inputBlur"
                                    class="rank-content-list-input"
                                    v-model="searchValue"
                                    @focus="focusInput"
                                    @input="onSearch"
                                    :maxLength="30"
                                    :disabled="voteType || onlyExtra"
                                    placeholder="搜索你想要的作品">
                                    <template #prefix>
                                        <div class="search-bar-icon"></div>
                                    </template>
                                </q-input>
                                <p class="rank-search-radio" v-show="!searchValue">
                                    <q-radio text="有番外的" @change="readioChange('onlyExtra')" v-if="store.pageData?.display_fanwai" v-model="onlyExtra" />
                                    <q-radio text="我投过票" @change="readioChange('voteType')" v-model="voteType" />
                                </p>
                            </div>
                            <div class="rank-search-result" v-if="seachFocus && rankList.length > 0">{{ searchValue ? '搜索结果' : '为你推荐' }}</div>
                            <div class="rank-list-wrap" ref="rankListRef">
                                <rank-item
                                    v-for="item in rankList"
                                    :key="`rank-item-${item.book_id}`"
                                    :ref="(el) => setRankItemRef(el, item?.book_id || '')"
                                    :book-info="item"
                                    :isRank="isNeedRankStyle"
                                    :shelf-book-ids.sync="bookshelfIds"
                                    :isSearch="seachFocus"
                                    @vote="onVote(item)"
                                    @refreshBookshelf="getBookshelfIds"
                                    :high-id="highId"
                                />
                                <!-- <p v-if="rankList.length" class="flex-1"></p> -->
                                <q-empty v-if="!rankList.length && !searchLoading" :key="`searchValue-${searchValue}`" :type="searchValue ? 'search' : 'data'" :tip="searchValue ? '暂时没有搜到任何书籍' : '暂无数据'"></q-empty>
                                <div ref="refLoadMore" v-show="rankList.length && !seachFocus">
                                    <QLoading client="freereader" endTitle="厉害！居然滑到底了！" :status="loadEnd ? '3' : '2'" title="加载中..."></QLoading>
                                </div>
                                <QLoading v-show="seachFocus" client="freereader" endTitle="厉害！居然滑到底了！" :status="searchLoading ? '2' : '3'" title="搜索中..."></QLoading>
                            </div>
                        </div>
                        <img class="rank-img-tail" src="@/assets/images/rank/rank_img_tail.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </qmWxBtn>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, nextTick, computed } from 'vue';
import QInput from '@common/components/q-input.vue';
import QRadio from '@common/components/q-radio.vue';
import RankItem from './item.vue';
import { QLoading, QEmpty } from '@q-front-npm/h5-ui';
import { useIntersectionObserver } from '@common/hooks/useIntersectionObserver';
import { useStoreCommon } from '@common/store/common';
import { apiGetRankingList, apiGetBookDetail, apiSearch } from '../../http/api';
import { getBookshelfInfo, schemaSingle } from '@q-front-npm/jsbridge';
import { useStore } from '../../store';
import qmWxBtn from '@common/components/qm-wx-btn.vue';
import Vue from 'vue';
import { handleLogin } from '@common/assets/ts/utils';
const storeCommon = useStoreCommon();
const store = useStore();
const refLoadMore = ref<HTMLElement>();

const { targetRef, isIntersecting, } = useIntersectionObserver({
    threshold: 0.2,
});

const searchValue = ref('');
const voteType = ref(false);
const onlyExtra = ref(false);
const searchLoading = ref(false);
const currentTab = ref('1');
const seachFocus = ref(false);
// 当前api请求tag, 用于防止请求结果错乱
let currentApiTag = 1;
const isNeedRankStyle = computed(() => {
    console.log('isNeedRankStyle', seachFocus.value, voteType.value, onlyExtra.value);
    console.log(seachFocus.value || (!voteType.value && !onlyExtra.value));
    if (seachFocus.value) return false;
    if (onlyExtra.value) return false;
    return true;
    // return !seachFocus.value && !voteType.value && !onlyExtra.value;
});

const rankItemRef = ref<Record<string, HTMLElement>>({});
const setRankItemRef = (el: InstanceType<typeof RankItem>, book_id: string) => {
    if (book_id && el) {
        rankItemRef.value[book_id] = el as HTMLElement;
    }
};

const onTabClick = (index: string) => {
    if (rankLoading.value || searchLoading.value) return Vue.prototype.$toast('请勿频繁操作～');
    searchValue.value = '';
    currentTab.value = index;
    seachFocus.value = false;
    getRankList(false);
};

// 示例列表数据，后续可改为接口数据
const rankList = ref([]);

const onVote = (item: Record<string, any>) => {
    if (!store.pageData?.vote_num || store.pageData?.vote_num <= 0) {
        Vue.prototype.$toast('许愿票不足，请先赚取~');
        return;
    }
    store.setPrizePopData({
        show: true,
        data: [{
            type: 2,
            ...item,
        }],
    });
};

// 源列表
const sourceList = ref([]);
const rankLoading = ref(false);
const getRankList = async(isFirst = false) => {
    currentApiTag++;
    const tag = currentApiTag;
    seachFocus.value = false;

    const params = {
        gender: currentTab.value,
        only_my_voted: voteType.value,
    };
    if (onlyExtra.value) {
        params.only_extra = onlyExtra.value;
    }
    rankLoading.value = true;
    const res = await apiGetRankingList(params).finally(() => {
        rankLoading.value = false;
    });
    if (tag !== currentApiTag) return;
    res?.list?.forEach((item: any, index: number) => {
        item.rank = index + 1;
        // 是否是数字，不是则显示-
        item.sort = isNaN(+item.sort) ? '-' : item.sort;
    });
    sourceList.value = res.list.filter((item: any) => !item.book_info);
    rankList.value = res.list.filter((item: any) => !!item.book_info);

    if (rankList.value.length === 0 && !voteType.value && !onlyExtra.value) {
        onSearch();
    }

    // 重置监听
    if (isFirst && refLoadMore.value) {
        targetRef.value = refLoadMore.value as HTMLElement;
        watch(isIntersecting, (newValue) => {
            if (newValue) {
                console.log(111111111);
                onLoadMore();
            }
        });
    } else {
        rankListRef.value?.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        loadEnd.value = sourceList.value.length === 0;
    }
};

const loadEnd = ref(false);
let isLoadmore = false;
const onLoadMore = async() => {
    if (isLoadmore) return;
    isLoadmore = true;
    if (sourceList.value.length === 0) {
        loadEnd.value = true;
        isLoadmore = false;
        return;
    }
    const books = sourceList.value.splice(0, 10);
    const res = await apiGetBookDetail({
        book_ids: books.map((item: any) => item.book_id),
    }).finally(() => {
        isLoadmore = false;
    });
    console.log('-----------------onLoadMore', books);
    books.forEach((item: any) => {
        item.book_info = res.book_list.find((book: any) => book.book_id === item.book_id);
    });
    rankList.value.push(...books);
};

let timeFn = null;
let successSeachText = '';
const onSearch = async() => {
    if (searchLoading.value) return;

    if (timeFn) clearTimeout(timeFn);

    // 这里注意一下， 外部不能设置焦点true，否则就无法触发请求了
    if (seachFocus.value && rankList.value.length > 0 && successSeachText === searchValue.value) return;

    currentApiTag++;
    const tag = currentApiTag;

    rankList.value = [];
    seachFocus.value = true;
    searchLoading.value = true;
    timeFn = setTimeout(async() => {
        const res = await apiSearch({
            words: searchValue.value,
            gender: currentTab.value,
            shelf_book_ids: bookshelfIds.value.slice(0, 10),
        }).finally(() => {
            searchLoading.value = false;
        });
        if (tag !== currentApiTag) {
            console.log('-----------------onSearch', tag, currentApiTag);
            return;
        }
        successSeachText = searchValue.value;
        rankList.value = res.list;
    }, 800);
};

const focusInput = () => {
    store.setIsInputFocus(true);
    onSearch();
};

const inputBlur = () => {
    store.setIsInputFocus(false);
    setTimeout(() => {
        console.log('-----------------inputBlur', searchValue.value, store.prizePopData.show, store.isNeedFocus);
        if (!searchValue.value && !store.prizePopData.show && !store.isNeedFocus) {
            rankList.value = [];
            seachFocus.value = false;
            getRankList(false);
        }
    }, 200);
};

const readioChange = (type: string) => {
    if (!handleLogin(storeCommon.userInfo.user_type.toString())) {
        voteType.value = false;
        onlyExtra.value = false;
        return;
    }
    nextTick(() => {
        if (rankLoading.value || searchLoading.value){
            Vue.prototype.$toast('请勿频繁操作～');
            if (type === 'onlyExtra') {
                onlyExtra.value = !onlyExtra.value;
            } else {
                voteType.value = !voteType.value;
            }
            return;
        }
        seachFocus.value = false;
        searchValue.value = '';
        getRankList(false);
    });
};

// 获取书架ids
const bookshelfIds = ref([]);
const getBookshelfIds = async() => {
    getBookshelfInfo().then((data: any): void => {
        console.log('-----------------getBookshelf data', data);
        bookshelfIds.value = (data?.split(',') || []).filter((item: string) => !!item);
    });
};

// 重排ranlist并且将指定book_id的数据滚动到rank-list-wrap的中间
const rankListRef = ref<HTMLElement>();
const highId = ref('');
const resetRankList = ({book_id, count,}: {book_id: string, count: number}) => {
    const index = rankList.value.findIndex((item: any) => item.book_id === book_id);
    if (index !== -1) {
        rankList.value[index].vote_num = +rankList.value[index].vote_num + +count;

        if (seachFocus.value || voteType.value) return;

        rankList.value.sort((a: any, b: any) => b.vote_num - a.vote_num);
        rankList.value.forEach((item: any, index: number) => {
            item.sort = index + 1;
        });
        // 滚动到指定位置
        setTimeout(() => {
            // if (rankListRef.value?.scrollTop < 100) return;
            // 如果在视图的可视区域，则不滚动
            if (rankListRef.value?.scrollTop < rankItemRef.value[book_id].$el.offsetTop) return;

            highId.value = book_id;
            setTimeout(() => {
                highId.value = '';
            }, 2500);
            rankListRef.value?.scrollTo({
                top: rankItemRef.value[book_id].$el.offsetTop - rankListRef.value.offsetHeight / 2,
                behavior: 'smooth',
            });
        }, 800);
    }
};

defineExpose({
    resetRankList,
});

const minHeight = ref(400);
onMounted(async() => {
    setTimeout(() => {
        minHeight.value = window.innerHeight * 0.7 - (storeCommon.inTopTab ? storeCommon.inTopTabNavHeight : 0);
    }, 800);
    await getBookshelfIds().catch(() => {});
    const apiFn = null;
    schemaSingle.runSchema('read_preference_select_status', {}, (p) => {
        currentTab.value = p == '2' ? '2' : '1';
        getRankList(true);
    }).catch(() => {
        getRankList(true);
    }).finally(() => {
        clearTimeout(apiFn);
    });
    // 兜底处理
    setTimeout(() => {
        getRankList(true);
    }, 2000);
});
</script>

<style lang="scss" scoped>
.rank-bg {
    position: relative;
    width: 672px;
    min-height: 60vh;
    margin: 0 auto;
    border-radius: 24px;
    // background: linear-gradient(180deg, rgba(255, 252, 238, 1), rgba(255, 252, 238, 0));
    // padding: 0.5px;
    box-sizing: border-box;
}
.rank-list {
    width: 100%;
    height: 100%;
    background: #FA9354;
    border-radius: 24px;
    padding: 12px 11px;
    border: 0.5px solid rgba(251, 219, 127, 0.6);
}
.rank-content {
    width: 648px;
    height: 100%;

}
.rank-tab-bg {
    position: absolute;
    width: 648px;
    height: 160px;
    .tab-bg-1, .tab-bg-2 {
        position: absolute;
        top: 0;
        width: 40%;
        height: 100%;
    }
    .tab-bg-1 {
        left: 0;
        background: #FFF5D8;
        border-radius: 20px 0 0 0;
    }
    .tab-bg-2 {
        right: 0;
        background: transparent;
    }
    .tab-img {
        position: absolute;
        top: 0;
        width: 220px;
        left: calc(50% - 104px);
        &[rotate] {
            transform: rotateY(180deg);
        }
    }
}
.rank-tab-bg-right {
    .tab-bg-1 {
        background: transparent!important;
        border-radius: 0 20px 0 0!important;
    }
    .tab-bg-2 {
        background: #FFF5D8!important;
        border-radius: 0 20px 0 0!important;
    }
}
.rank-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
}
.rank-tab-list {
    width: 100%;
    height: 92px;
    display: flex;
    li {
        flex: 1;
        text-align: center;
        font-size: 36px;
        color: #5F2901;
        line-height: 92px;
        font-weight: bold;
        &[disabled] {
            color: #FFFDF2;
            font-size: 34px;
        }
    }
}
.rank-content-list {
    flex: 1;
    background: linear-gradient( 180deg, #FFF5D9 0%, #FDEEB6 100%);
    border-radius: 0 20px 0 0;
    padding: 33px 20px 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.rank-content-list-right {
    border-radius: 20px 0 0 0!important;
}
.rank-search {
    display: flex;
    align-items: center;
    min-height: 64px;
    margin-bottom: 32px;
}
.rank-search.rank-search-radio-only {
    justify-content: flex-end;
}
.rank-content-list-input {
    height: 64px;
    flex: 1;
}
.rank-search-radio {
    min-width: 208px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    &::v-deep(.q-radio-container) {
        margin-left: 20px;
    }
}

.rank-list-wrap {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    // 不展示滚动条
    scrollbar-width: none;
    -ms-overflow-style: none;
    // display: flex;
    // flex-direction: column;
    &::-webkit-scrollbar {
        display: none;
    }
    // max-height: calc(100% - 84px);

}
.flex-1 {
    flex: 1;
}
.rank-img-tail {
    position: absolute;
    bottom: -130px;
    left: -26px;
    width: 700px;
    pointer-events: none;
}
.search-bar-icon {
    min-width: 0.48rem;
}
.rank-search-result {
    font-weight: bold;
    font-size: 30px;
    color: rgba(17,17,17,0.8);
    line-height: 42px;
    margin-left: 28px;
    margin-bottom: 24px;
}
</style>
